import { render, staticRenderFns } from "./activitys.vue?vue&type=template&id=6f842d72&scoped=true&"
import script from "./activitys.vue?vue&type=script&lang=js&"
export * from "./activitys.vue?vue&type=script&lang=js&"
import style0 from "./activitys.vue?vue&type=style&index=0&id=6f842d72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f842d72",
  null
  
)

export default component.exports